// src/components/ProtectedRoute.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Navigate, Outlet, useLocation, matchPath } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

const getAccessToken = () =>
  localStorage.getItem("accessToken") ||
  localStorage.getItem("token") ||
  localStorage.getItem("contractor_access_token") ||
  "";

const ProtectedRoute = () => {
  const location = useLocation();
  const [pages, setPages] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(true);

  useEffect(() => {
    const headers = {};
    const accessToken = getAccessToken();
    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }

    axios
      .get(`${API_URL}/user-profile`, {
        withCredentials: true,
        headers,
      })
      .then((data) => {
        const allowed = data?.data?.pages || [];
        setPages(allowed);
        localStorage.setItem("userPages", JSON.stringify(allowed));
      })
      .catch((err) => {
        console.error("Error fetching user profile:", err);
        setAuthorized(false);
        setPages([]);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return null;
  }

  if (!authorized) {
    return <Navigate to="/sign-in" replace />;
  }

  if (pages) {
    const isAllowed = pages.some((path) =>
      matchPath({ path: `${path}/*` }, location.pathname) // allow children paths too
    );

    if (!isAllowed) {
      return <Navigate to="/access-denied" replace />;
    }
  }
  return <Outlet />;
};

export default ProtectedRoute;
